// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".wrap-detail-card {\r\n  overflow: hidden !important;\r\n}\r\n\r\n.wrap-title {\r\n  white-space: nowrap !important;\r\n}\r\n", "",{"version":3,"sources":["webpack://src/Compare/Comparision.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC","sourcesContent":[".wrap-detail-card {\r\n  overflow: hidden !important;\r\n}\r\n\r\n.wrap-title {\r\n  white-space: nowrap !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
